// import { useState, useEffect } from 'react';
// import { X } from 'lucide-react';

// NOTE: The @magicbell/react v1.5.0 API doesn't export useNotifications hook
// The FloatingInbox component handles notification display instead
// This banner component is temporarily disabled until we find the correct API
// for real-time notification listening in the new SDK version

export function NotificationBanner() {
  // Temporarily disabled - API not available in @magicbell/react v1.5.0
  // The FloatingInbox component provides notification display functionality
  return null;
}

export default NotificationBanner;

